import { useState } from "react";
import { useParams } from "react-router-dom";
import { BrandLockup } from "@/components/Wordmark";
import { inr, media } from "@/lib/format";
import { KioskProvider, useKiosk } from "./KioskContext";
import { specRows } from "./specs";

function Inner() {
  const { slug } = useParams();
  const { data, t, tx } = useKiosk();
  const [c, setC] = useState(0);
  if (!data) return <div className="grid h-screen place-items-center"><BrandLockup size={32} /></div>;
  const m = data.models.find((x) => x.slug === slug) || data.models[0];
  const col = m.colours[c] || {};
  return (
    <main className="mx-auto max-w-[640px] px-5 pb-12" data-testid="take-home-page">
      <header className="flex h-16 items-center"><BrandLockup size={24} /></header>
      <p className="text-[15px] font-semibold text-[#087568]">{m.category}</p>
      <h1 className="font-display text-5xl font-extrabold leading-none tracking-[-0.045em]">{m.name}</h1>
      <p className="mt-2 text-[17px] text-[#6E6E73]">{tx(m.tagline)}</p>
      <div className="tile mt-6 p-5">
        <img src={media(col.image)} alt={m.name} className="product-shadow h-56 w-full object-contain" data-testid="take-home-image" />
        <div className="mt-4 flex flex-wrap items-center gap-3">
          {m.colours.map((x, i) => (
            <button key={x.name} onClick={() => setC(i)} aria-label={x.name} className={`h-11 w-11 rounded-full ring-1 ring-black/10 ${i === c ? "ring-2 ring-[#0B8577] ring-offset-2" : ""}`} style={{ background: x.hex }} />
          ))}
          <span className="text-[15px] font-medium">{col.name}</span>
        </div>
      </div>
      <div className="tile mt-4 p-5">
        <p className="text-[15px] font-medium text-[#6E6E73]">{t("variants")}</p>
        {m.variants.map((v) => <div key={v.name} className="flex justify-between py-2 text-[15px]"><span>{v.name}</span><span className="font-semibold tnum">{inr(v.price)}</span></div>)}
        <p className="mt-2 text-[12px] text-[#6E6E73]">{t("exShowroom")} · {t("indicative")} · {t("priceAsOn")} {m.price_as_on}</p>
      </div>
      <dl className="tile mt-4 divide-y divide-[#E5E5EA] p-5">
        {specRows(m, t).map((r) => <div key={r.key} className="flex justify-between py-2.5 text-[15px]"><dt className="text-[#6E6E73]">{r.label}</dt><dd className="font-semibold">{r.value}</dd></div>)}
      </dl>
      <a href={m.url} target="_blank" rel="noreferrer" className="btn-pill btn-teal mt-6 w-full" data-testid="take-home-tvs-link">tvsmotor.com</a>
      <p className="mt-4 text-center text-[13px] text-[#6E6E73]">{data.showroom?.name} · {data.showroom?.area}</p>
    </main>
  );
}

export default function TakeHome() {
  return <KioskProvider live={false}><Inner /></KioskProvider>;
}
